import { SET_CUSTOMER } from "./types";

export const setCustomer = (cliente) => (dispatch) => {
  dispatch({
    type: SET_CUSTOMER,
    payload: cliente,
  });
};